import React, { useEffect, useState } from 'react';
import { Input, Select, Modal, message, Spin } from 'antd';
import { Link, id, dispatch, useParams } from 'react-router-dom';
import { PrivateAxiosInstance } from '../../../services/createAxiosInstance'
import { URLs } from '../../../constants/apiEndpoints'
import { useDispatch, useSelector } from 'react-redux';
import { deleteSession } from '../../../redux/features/sessions/sessionActions';
import Pagination from '../../../components/Pagination/Pagination';

const { Search } = Input;

function SingleCollection() {
    const [Getloading, setGetLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [statusFilter, setStatusFilter] = useState('');
    const [currentPage, setCurrentPage] = useState(1); // Keep track of current page
    const [totalPages, setTotalPages] = useState(1)

    const dispatch = useDispatch();
    const { id } = useParams()

    const { loading, data } = useSelector((state) => state.session);

    const handleSearch = (value) => {
        setSearchText(value);
    };


    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchData = async () => {
        setGetLoading(true)
        try {
            const url = `${URLs.GET_BY_SINGlE_COLLECTION}/${id}`;
            const res = await PrivateAxiosInstance.get(url);

            const status = res?.data?.success
            const data = res?.data?.event
            const totalPage = res?.data?.pages

            if (status) {
                setFilteredData(data)
                setTotalPages(totalPage);
            } else {
                message.error('No Collection data found');
            }
        } catch (err) {
            message.error('Something went wrong during fetching Collection data');
        } finally {
            setGetLoading(false)
        }
    };

    useEffect(() => {
        fetchData();
    }, [currentPage, searchText, statusFilter, id, dispatch]);


    const tableHeaders = ['Id', 'Event Name', 'Action'];


    const handleDelete = async (eventId) => {
        try {
            await dispatch(deleteSession({ eventId: eventId })).unwrap();
            fetchData();

            message.success('Delete successfully!');
        } catch (err) {
            const errorMessage = err.error || 'Failed to Delete sessions';
            message.error(errorMessage);
        }
    };


    const showConfirm = (eventId) => {
        Modal.confirm({
            title: 'Confirm Delete',
            content: 'Are you sure you want to delete a session?',
            okText: 'Yes, Delete',
            cancelText: 'No',
            onOk() {
                handleDelete(eventId);
            },
        });
    };




    return (
        <>
            <div className="font-poppins overflow-x-auto mt-[70px]">

                <Spin spinning={loading} fullscreen />
                <Spin spinning={Getloading} fullscreen />

                <h2 className='text-white text-xl  md:text-2xl font-bold text-start mb-5 '>Collection Title: {filteredData.eventCollectionName}</h2>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 md:gap-6 bg-background-secondary-color justify-between p-3 w-full rounded-t-lg">
                    {/* Search bar */}
                    <div className=" ml-[-20px]  w-[400px] mb-3 md:ml-[0px] lg:ml-[P0px] mt-3 sm:mt-0 sm:ml-[0px] group">
                        {/* <Search
                            placeholder="Search by name"
                            onChange={(e) => handleSearch(e.target.value)}
                            value={filters.searchText}
                            style={{
                                width: 250,
                                margin: '10px 10px 0px 20px',
                            }}
                            className='pr-3'
                        /> */}

                    </div>

                    <h4 className='text-md ml-[20px] mt-3 font-poppins font-bold text-white'>Collection ID :
                        <span className='text-md mt-3 font-normal text-white'> {filteredData.eventCollectionId || 'No ID'}</span>
                    </h4>

                    {/* <h4 className='text-md ml-[20px] mt-3 font-poppins font-bold text-white'>Available Seats :
                        <span className='text-md mt-3 font-normal text-white'>  {sessionData?.numOfSeats || 'No limit'}</span>
                    </h4> */}

                    <h4 className='text-md ml-[20px] mt-3 font-poppins font-bold text-white'>Total Sessions :
                        <span className='text-md mt-3 font-normal text-white'>{' '}{filteredData?.events?.length || 'No data'}</span>
                    </h4>


                </div>

                {/* Table headers */}
                <table className="min-w-full bg-white">
                    <thead className="bg-gray-950 whitespace-nowrap">
                        <tr>
                            {tableHeaders.map((header, index) => (
                                <th key={index} className="p-4 text-left text-sm font-medium font-poppins text-white">
                                    {header}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    {/* Table row */}
                    <tbody className="whitespace-nowrap">
                        {filteredData?.events?.length > 0 ? (
                            filteredData?.events?.map((data, index) => (
                                <tr key={index} className="bg-gray-800 odd:bg-gray-700 hover:bg-red-900">
                                    <td className="p-4 text-sm text-gray-200 font-poppins">
                                        {data?.eventId || 'No data'}
                                    </td>
                                    <td className="p-4 text-sm text-gray-200 font-poppins">
                                        {data?.eventName || 'No data'}
                                    </td>

                                    <td>
                                        <button onClick={() => showConfirm(data?.eventId)} title="Delete">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 fill-red-500 hover:fill-red-700" viewBox="0 0 24 24">
                                                <path d="M19 7a1 1 0 0 0-1 1v11.191A1.92 1.92 0 0 1 15.99 21H8.01A1.92 1.92 0 0 1 6 19.191V8a1 1 0 0 0-2 0v11.191A3.918 3.918 0 0 0 8.01 23h7.98A3.918 3.918 0 0 0 20 19.191V8a1 1 0 0 0-1-1Zm1-3h-4V2a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2H4a1 1 0 0 0 0 2h16a1 1 0 0 0 0-2ZM10 4V3h4v1Z" data-original="#000000" />
                                                <path d="M11 17v-7a1 1 0 0 0-2 0v7a1 1 0 0 0 2 0Zm4 0v-7a1 1 0 0 0-2 0v7a1 1 0 0 0 2 0Z" data-original="#000000" />
                                            </svg>
                                        </button>
                                    </td>

                                </tr>
                            ))) : (
                            <tr>
                                <td colSpan={7} className="text-center p-4">
                                    No Data Available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>


                <>
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />
                </>

            </div>
        </>
    );
}

export default SingleCollection;


